/**
 * exportChartPNG.js - rasterise a Recharts SVG to a PNG download, so a chart
 * can be pasted into a deck without a screenshot tool.
 */

// html2canvas is loaded on first use, so it stays out of the main bundle.
export const exportChartPNG = async (ref, filename) => {
  if (!ref.current) return;
  const html2canvas = (await import('html2canvas')).default;
  const canvas = await html2canvas(ref.current, { backgroundColor: '#ffffff', scale: 2 });
  const url = canvas.toDataURL('image/png');
  const a = document.createElement('a');
  a.href = url;
  a.download = (filename || 'chart') + '.png';
  a.click();
};
